import { post, get } from '@/utils/request';

// 获取字典菜单列表
export function DictMenuList() {
  return post('/Dictionary/Menu/List');
}

// 保存字典菜单 (新增/编辑)
export function DictMenuSave(data) {
  return post('/Dictionary/Menu/Save', data);
}

// 删除字典菜单
export function DictMenuDelete(data) {
  return post('/Dictionary/Menu/Delete', data);
}

// 获取某字典分类下的数值列表
export function DictDataList(data) {
  return post('/Dictionary/Data/List', data);
}

// 保存字典数值 (新增/编辑)
export function DictDataSave(data) {
  return post('/Dictionary/Data/Save', data);
}

// 删除字典数值
export function DictDataDelete(data) {
  return post('/Dictionary/Data/Delete', data);
}

// 根据字典编码获取字典数值列表
export function DictDataByCode(code) {
  return post('/Dictionary/Data/ByCode', { code });
}
